import { render } from "./menuAdd.vue?vue&type=template&id=2973cefc&ts=true"
import script from "./menuAdd.vue?vue&type=script&lang=ts"
export * from "./menuAdd.vue?vue&type=script&lang=ts"

import "./menuAdd.vue?vue&type=style&index=0&id=2973cefc&lang=scss"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__